import { css } from 'linaria';

export const reviewAnswerWrapper = css`
  padding: 24px;
  background-color: var(--background-secondary);
  border-radius: 24px;
`;

export const reviewAnswerText = css`
  width: 100%;
  word-wrap: break-word;
`;

export const firstRow = css`
  display: flex;
  align-items: center;
  margin-bottom: 11px;
`;

export const personTitle = css`
  margin-inline-start: 12px;
`;

export const personContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: var(--space-150);
`;
